import * as React from 'react'

import { dayjs } from '@/lib/dayjs'
import { cn } from '@/lib/utils.ts'
import { CalendarEvent } from '@/features/calendar/types'

import { EventComponent } from './event-component.tsx'

type WeekViewProps = {
  currentDate: Date
  events?: CalendarEvent[]
}

export const WeekView: React.FC<WeekViewProps> = ({ currentDate, events }) => {
  const weekStart = dayjs(currentDate).startOf('week')
  const weekEnd = dayjs(currentDate).endOf('week')
  const days = []
  let day = weekStart
  while (day.isBefore(weekEnd) || day.isSame(weekEnd, 'day')) {
    days.push(day)
    day = day.add(1, 'day')
  }

  return (
    <div className="bg-muted grid grid-cols-7 gap-px overflow-hidden rounded-lg border">
      {days.map((day) => (
        <div key={day.toString()} className="bg-background min-h-[250px] p-2">
          <div className="mb-2 text-center text-sm font-medium">
            <span
              className={cn(
                day.isSame(dayjs(), 'day') &&
                  'bg-primary text-primary-foreground rounded-full px-2 py-1'
              )}
            >
              {day.format('ddd D')}
            </span>
          </div>
          <div className="space-y-1">
            {events
              ?.filter(
                (event) =>
                  day.isSameOrAfter(dayjs(event.start_date)) &&
                  day.isSameOrBefore(dayjs(event.end_date))
              )
              .map((event, index) => (
                <EventComponent key={index} event={event}>
                  <div
                    className={cn(
                      'bg-secondary line-clamp-2 cursor-pointer rounded p-1 text-xs'
                    )}
                  >
                    {event.title}
                  </div>
                </EventComponent>
              ))}
          </div>
        </div>
      ))}
    </div>
  )
}
